/**
 * @generated SignedSource<<b6a9a4c2fe57c3d009d70924bcfb7594>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useFDFQuoteVariant_relevantShipping$data = {
  readonly shipmentQuotes: ReadonlyArray<{
    readonly isFromDealer: boolean | null;
    readonly isFromInternal: boolean | null;
    readonly isShipmentSubsidized: boolean | null;
    readonly serviceMethod: {
      readonly isFreight: boolean | null;
      readonly serviceType: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "useFDFQuoteVariant_relevantShipping";
};
export type useFDFQuoteVariant_relevantShipping$key = {
  readonly " $data"?: useFDFQuoteVariant_relevantShipping$data;
  readonly " $fragmentSpreads": FragmentRefs<"useFDFQuoteVariant_relevantShipping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useFDFQuoteVariant_relevantShipping",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentQuote",
      "kind": "LinkedField",
      "name": "shipmentQuotes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ShipmentServiceMethod",
          "kind": "LinkedField",
          "name": "serviceMethod",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isFreight",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFromDealer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFromInternal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShipmentSubsidized",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RelevantShippingInfo",
  "abstractKey": null
};

(node as any).hash = "25ae74e959609f19eff5a6b005cc6011";

export default node;
